import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    alignSelf: 'stretch',
    height: 1,
    margin: theme.spacing(1, 2),
    border: 'none',
    backgroundColor: theme.palette.navigation.color,
    opacity: 0.2,
  },
}));

/** Thin separator between sidebar sections, in the sidebar text color. */
export const NavDivider = () => <hr className={useStyles().root} />;
